module.exports = __webpack_public_path__ + "hyperion-v2-static/img/download_android.5531e80a.png";